import React from 'react';
import { IconButton, MenuItem, Menu } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';

const ITEM_HEIGHT = 48;
interface Props {
  productId: number;
  parentId: number;
  setOpenEnterProduct: (open: boolean) => void;
  setOpenAdjustment: (open: boolean) => void;
  setParentId: (parentId: number) => void;
  setProductId: (productId: number) => void;
}

export default function IMInventoryMenu({
  productId,
  parentId,
  setParentId,
  setOpenEnterProduct,
  setOpenAdjustment,
  setProductId
}: Props) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <React.Fragment>
      <IconButton onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        PaperProps={{
          elevation: 3,
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: '20ch'
          }
        }}
      >
        <MenuItem
          key={1}
          value="enter"
          onClick={() => {
            setOpenEnterProduct(true);
            setProductId(productId);
            setParentId(parentId);
            handleClose();
          }}
        >
          Entrada
        </MenuItem>
        <MenuItem
          key={2}
          value="release"
          onClick={() => {
            setOpenAdjustment(true);
            setProductId(productId);
            setParentId(parentId);
            handleClose();
          }}
        >
          Ajuste
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
}
